import { ArrowLeft } from "@carbon/icons-react";
import { Toolbar, ToolbarAction, ToolbarActions } from "@flaminem/ui-components";
import { FC } from "react";
import { useSearchParams } from "react-router-dom";

import ExecutionResultsView, {
  ExecutionResultsViewProps,
} from "src/dynamic-view-renderer/Widgets/ExecutionsWidget/ExecutionResultsView.tsx";
import WidgetContainer, {
  WidgetContainerProps,
} from "src/dynamic-view-renderer/Widgets/WidgetContainer.tsx";
import WidgetRenderer from "src/dynamic-view-renderer/Widgets/WidgetRenderer.tsx";
import { useT } from "src/internationalization";

export type ExecutionsWidgetProps = {
  data?: ExecutionResultsViewProps;
} & Omit<WidgetContainerProps, "children">;

export const ExecutionsWidget: FC<ExecutionsWidgetProps> = ({ data, ...containerProps }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const t = useT();

  const executionResults = data?.executionResults;
  const executionResultId = searchParams.get("executionId");

  const currentExecutionResult =
    executionResults?.find((result) => result.id === executionResultId) ?? null;

  const handleBack = () => {
    searchParams.delete("executionId");
    setSearchParams(searchParams);
  };
  return !currentExecutionResult ? (
    <WidgetContainer {...containerProps} header={<></>} className="!p-0">
      <ExecutionResultsView {...data} snapshotMode={data?.snapshotMode} />
    </WidgetContainer>
  ) : (
    <div className="flex flex-col w-full">
      <Toolbar className="justify-start bg-background">
        <ToolbarActions className={"flex items-center gap-2"}>
          <ToolbarAction label={t("component.button.back")} onClick={handleBack}>
            <ArrowLeft />
          </ToolbarAction>
          <span>{currentExecutionResult.scenarioVersion?.scenario?.name}</span>
        </ToolbarActions>
      </Toolbar>
      <WidgetRenderer
        data={{
          widgetsData: {
            executionDetails: {
              executionResult: currentExecutionResult,
              selectedCase: data?.selectedCase,
            },
          },
        }}
        rowConfiguration={{ widgets: [{ widgetCode: "executionDetails" }] }}
        widgetConfig={{ widgetCode: "executionDetails" }}
      />
    </div>
  );
};
